module.exports = __webpack_public_path__ + "img/level6-2.316f7a2d.png";